import request from "@/http/http"
import { handleBoardResult } from "./helper"

export const getBoards = async (offset = 0, limit = 500) => {
  try {
    const result = await request.get("/v1/boards", {
      params: { offset, limit },
    })
    return result.data
  } catch (error) {}
}

export const addBoard = async (name: string, type: string | number) => {
  try {
    const result = await request.post("/v1/boards", {
      name,
      type,
    })
    return result.data
  } catch (error) {}
}

export const getBoard = async (id: string | number) => {
  try {
    const result = await request.get(`/v1/boards/${id}`)
    return handleBoardResult(result)
  } catch (error) {
    console.log(`WAYZ: getBoard -> error`, error)
  }
}

export const updateBoard = async (id: string | number, data: any) => {
  try {
    const result = await request.put(`/v1/boards/${id}`, {
      data,
    })
    return result.status
  } catch (error) {}
}

export const deleteBoard = async (id: string | number) => {
  try {
    const result = await request.delete(`/boards/${id}`)
    const { status } = result
    return status
    // return 200
  } catch (error) {}
}

// 获取分享列表

export const getShareBoards = async (offset = 0, limit = 10, ownerType = 2) => {
  try {
    let params = { offset: (offset - 1) * limit, limit, ownerType }
    const result = await request.get(`/v1/boards`, { params })
    let { data = { item: [], total: 0 } } = result
    return data
  } catch (error) {
    console.log(`WAYZ: getShareBoards -> error`, error)
  }
}

// 分享面板
export const shareBoard = async (boardId: string) => {
  try {
    const result = await request.post("/v1/share/board", {
      boardId: boardId,
      lookUsers: [],
      type: 2,
    })
    return result.data
  } catch (error) {
    console.error("分享失败", error)
    return null
  }
}
